var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00002 11C4.00002 7.13401 7.13402 4 11 4C14.866 4 18 7.13401 18 11C18 12.8859 17.2543 14.5975 16.0416 15.8562C16.0073 15.8826 15.9743 15.9114 15.9429 15.9428C15.9115 15.9742 15.8826 16.0072 15.8563 16.0415C14.5976 17.2542 12.8859 18 11 18C7.13402 18 4.00002 14.866 4.00002 11ZM16.6177 18.0319C15.0781 19.2635 13.125 20 11 20C6.02945 20 2.00002 15.9706 2.00002 11C2.00002 6.02944 6.02945 2 11 2C15.9706 2 20 6.02944 20 11C20 13.125 19.2636 15.078 18.0319 16.6176L21.7071 20.2928C22.0977 20.6834 22.0977 21.3165 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.6177 18.0319Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.56191a91.svg";
export { ForwardRef as ReactComponent };